// extracted by mini-css-extract-plugin
export default {"lens-ui-font-definition":"qx_nTdWMOHCpM_SeRsYS","lensUiFontDefinition":"qx_nTdWMOHCpM_SeRsYS","divider":"ZGBlA7aiU_UPkdG9NLBL"};